import {
  ItemsResponse,
  PENDING_CASH_PARSER,
  SingleResponse,
  parseErrorContainer,
  type JsonHelper,
  type pendingCashEntry,
} from "../../../tastyworks"
import {
  ADMIN_BALANCE_PARSER,
  type AdminBalance,
} from "../../../tastyworks/admin/admin-balances"
import type HttpClient from "../../../tastyworks/http"

export class AdminBalancesService {
  private readonly adminBalanceClient: HttpClient

  constructor(adminBalanceClient: HttpClient) {
    this.adminBalanceClient = adminBalanceClient.nested("accounts")
  }

  readonly index = async (
    accountNumber: string
  ): Promise<SingleResponse<AdminBalance>> =>
    this.adminBalanceClient
      .nested(accountNumber)
      .get("balances")
      .then((res) => this.populateResult(res))

  readonly pendingCash = async (
    accountNumber: string
  ): Promise<ItemsResponse<pendingCashEntry>> =>
    this.adminBalanceClient
      .nested(accountNumber)
      .get("pending-cash-entries")
      .then((res) => this.populatePendingCashResult(res))

  private readonly populateResult = (
    helper: JsonHelper
  ): SingleResponse<AdminBalance> => {
    const response = new SingleResponse<AdminBalance>()
    parseErrorContainer(helper, response)

    if (!helper.hasField("data")) {
      return response
    }
    const data = helper.getChild("data")
    response.data = ADMIN_BALANCE_PARSER(data)
    return response
  }

  private readonly populatePendingCashResult = (
    helper: JsonHelper
  ): ItemsResponse<pendingCashEntry> => {
    const response = new ItemsResponse<pendingCashEntry>()
    parseErrorContainer(helper, response)

    if (!helper.hasField("data")) {
      return response
    }
    const data = helper.getChild("data")

    response.items = data.parseArray("items", PENDING_CASH_PARSER)
    return response
  }
}
